export interface IOwnerManipulationService {

  StopSharing(fromUserId: number, toUserId: number, objectIds: number[])

  SetOwner(fromUserId: number, toUserId: number, objectIds: number[])

  ShareObject(fromUserId: number, toUserId: number, objectIds: number[])

  GetUserObjects(targetId: number)
}


export class ShareObjectViewModel {
    FromCompanyId: number;
    ToUserId: number;
    ObjectIds: number[];

    constructor(FromUserId: number, ToUserId: number, ObjectIds: number[])
    {
        this.FromCompanyId = FromUserId;
        this.ToUserId = ToUserId;
        this.ObjectIds = ObjectIds;
    }
}
